import Beacons from 'modules/beacons/utils';

export const impressionListener = (adserverRequestId: string, autoPlay: boolean) => {
  Beacons.fire.videoStart(adserverRequestId, autoPlay, true);
};
